// ── One card surface, defined once ────────────────────────────────────────────────────────────
//
// ⚠ THE CONTROL PAGE HAD TWO. The status tiles used one border/background pair and the people
// lanes another, so three cards sitting in the same section looked like two different kinds of
// object — and the difference read as meaning something it did not. Nothing about a card's STATE
// should be carried by its background: state is a badge, a dot, or words.
//
// Imported by both the page and the lane cards so they cannot drift apart again.
export const CARD_SURFACE = 'rounded-[10px] border border-cert-neutral-border bg-bg-surface';
